<template>
  <section class="video-intro page-common" data-aos="fade-down">
    <h2 class="title <tablet:hidden">業界好評推薦，美業老師愛用的預約系統</h2>
    <h2 class="title tablet:hidden">
      業界好評推薦，<br />
      美業老師愛用的預約系統
    </h2>
    <div class="sub">
      威許移動推出的「美業歐巴」預約系統，<br />
      整合線上預約、會員經營、美業行銷、店務管理功能，<span class="high-light"
        >深受 3,000 位美業老師好評！</span
      >
    </div>

    <main class="flex <laptop:flex-wrap gap-[20px] justify-center">
      <!-- <video controls class="video">
        <source src="https://youtu.be/5UV7TvQaiHs">
        抱歉，你的瀏覽器不支援此功能
      </video> -->
      <iframe
        class="video"
        src="https://www.youtube.com/embed/ZJJ-HtkCzwg"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      >
      </iframe>

      <article class="shop-rank-card">
        <header class="flex flex-col text-left">
          <span class="text-sub text-tertiary-dark">範例店家</span>
          <span class="font-medium">Heidimeimei 黑蒂美美</span>
        </header>

        <div class="rank-container">
          <section class="rank">
            <p class="text-md font-medium mb-[11px] mt-[23px]">訂單成長</p>
            <div class="flex items-center justify-center">
              <img
                class="h-[50px] mr-[14.77px]"
                :src="arrowUp"
                alt="arrow-up"
              />
              <span
                class="font-bold text-h2 <tablet:text-[40px] text-primary-blue"
                >37%</span
              >
            </div>
          </section>

          <section class="rank">
            <p class="text-md font-medium mb-[11px] mt-[23px]">會員成長</p>
            <div class="flex items-center justify-center">
              <img
                class="h-[50px] mr-[14.77px]"
                :src="arrowUp"
                alt="arrow-up"
              />
              <span
                class="font-bold text-h2 <tablet:text-[40px] text-primary-blue"
                >58%</span
              >
            </div>
          </section>

          <!-- <div class="<laptop:w-full">
            <button
              class="bg-secondary-100 text-white font-medium px-[20px] py-[6px] w-[107px] mt-[30px]"
            >
              更多案例
            </button>
          </div> -->
        </div>
      </article>
    </main>
  </section>
</template>
<script setup>
import arrowUp from '@/assets/icon/arrow-up.svg'
</script>
<style lang="postcss" scoped>
.video-intro {
  @apply pb-[56px];
}

.title {
  @apply mb-[28px] text-[40px] leading-[1.3];
  @apply <tablet: (mb-[16px] text-[24px] leading-[1.3]);
}

.sub {
  @apply font-medium text-[14px] leading-[20.27px] tracking-[1px] mb-[12px];
  @apply tablet: (text-[24px] leading-[34.75px] max-w-[1225px] text-center m-auto mb-[40px]);
}

.high-light {
  @apply text-primary-blue;
}

.video {
  @apply max-h-[390px] rounded-sm max-w-[691px] w-full <tablet: h-[390px] min-h-[300px];
}

.shop-rank-card {
  @apply flex flex-col px-[20px] py-[24px] w-[285px] flex-shrink-0 border-2 border-primary-100;
  @apply bg-white rounded-sm rounded-tr-[30px] rounded-bl-[30px];
  @apply <laptop: m-auto border-[4px];

  .rank-container {
    @apply flex flex-col h-full justify-between items-center;
    @apply <desktop: justify-around <laptop:flex-wrap <laptop:flex-row;
  }
}
</style>
